import dayjs from 'dayjs';
import type { CargoAddressRes, CargoRes } from 'api/swagger';
import { formatCoordinates } from 'shared/utils/coordinates';
import type { IAddressFormFields, ICargoFormFields } from 'components/cargos/cargo-form';

const prepareAddressObject = (address: CargoAddressRes): IAddressFormFields => {
  return {
    name: address.name,
    countryId: address.countryId,
    postCode: address.postCode,
    city: address.city,
    address: address.address,
    description: address.description,
    referenceNumber: address.referenceNumber,
    extraData: address.extraData,
    coordinates: formatCoordinates(address.lat, address.lng),
  };
};

export const prepareInitialValue = (cargo: CargoRes): ICargoFormFields => {
  return {
    loadingDate: [dayjs(cargo.loadingDateFrom), dayjs(cargo.loadingDateTo)],
    unloadingDate: [dayjs(cargo.unloadingDateFrom), dayjs(cargo.unloadingDateTo)],
    loadingCustom: cargo.loadingCustom,
    unloadingCustom: cargo.unloadingCustom,
    totalWeight: cargo.totalWeight,
    type: cargo.type,

    loadingAddress: prepareAddressObject(cargo.loadingAddress),
    unloadingAddress: prepareAddressObject(cargo.unloadingAddress),

    ...(cargo.assetReturnAddress ? { assetReturnAddress: prepareAddressObject(cargo.assetReturnAddress) } : {}),

    ...(cargo.loadingCustomAddress ? { loadingCustomAddress: prepareAddressObject(cargo.loadingCustomAddress) } : {}),

    ...(cargo.unloadingCustomAddress
      ? { unloadingCustomAddress: prepareAddressObject(cargo.unloadingCustomAddress) }
      : {}),
  };
};
